var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69684 11.1409L15.085 1.83887M6.69684 11.1409L9.36579 17.0603C9.39925 17.1413 9.45296 17.2099 9.52055 17.258C9.58814 17.3061 9.66676 17.3317 9.74707 17.3317C9.82738 17.3317 9.906 17.3061 9.97359 17.258C10.0412 17.2099 10.0949 17.1413 10.1283 17.0603L15.085 1.83887M6.69684 11.1409L1.35894 8.18115C1.28593 8.14405 1.22406 8.08448 1.18069 8.00953C1.13732 7.93458 1.11426 7.84739 1.11426 7.75833C1.11426 7.66927 1.13732 7.58208 1.18069 7.50713C1.22406 7.43218 1.28593 7.37261 1.35894 7.33551L15.085 1.83887",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoTo);
export default __webpack_public_path__ + "static/media/go-to.3289c63123fa62c0f1617103fd32a1d3.svg";
export { ForwardRef as ReactComponent };